<template>
  <div class="lang-selector-wrapper" ref="dropdownRef">
    <!-- زر فتح/إغلاق القائمة المنسدلة -->
    <button 
      type="button" 
      class="lang-trigger-btn" 
      :class="{ 'is-active': isOpen }" 
      @click="toggleDropdown"
      aria-haspopup="listbox"
      :aria-expanded="isOpen"
    >
      <span class="flag-icon" :class="getFlagClass(currentLocale)"></span>
      <span class="lang-label">{{ getLangName(currentLocale) }}</span>
      <ion-icon name="chevron-down-outline" class="arrow-icon"></ion-icon>
    </button>

    <!-- القائمة المنسدلة للغات -->
    <transition name="dropdown-anim">
      <div v-if="isOpen" class="lang-menu" role="listbox">
        <div 
          v-for="locale in availableLanguages" 
          :key="locale.code"
          class="lang-item"
          :class="{ 'is-selected': currentLocale === locale.code }"
          @click="selectLanguage(locale.code)"
          role="option"
          :aria-selected="currentLocale === locale.code"
        >
          <div class="lang-item-content">
            <span class="flag-icon" :class="locale.flag"></span>
            <div class="lang-text">
              <span class="lang-native-name">{{ locale.nativeName }}</span>
              <!-- <span class="lang-sub-code">{{ locale.code.toUpperCase() }}</span> -->
            </div>
          </div>
          
          <ion-icon 
            v-if="currentLocale === locale.code" 
            name="checkmark-circle" 
            class="check-icon"
          ></ion-icon>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import 'flag-icons/css/flag-icons.css';
import { _changeSwitchLang } from '../../i18u';

export default {
  name: 'LanguageDropdown',
  data() {
    return {
      isOpen: false,
      // تعريف اللغات المدعومة مع أسماء واضحة وعلم كل لغة
      languagesList: {
        ar: { code: 'ar', flag: 'fi fi-sy', nativeName: 'العربية' },
        ae: { code: 'ae', flag: 'fi fi-ae', nativeName: 'العربية' },
        tr: { code: 'tr', flag: 'fi fi-tr', nativeName: 'Türkçe' },
        en: { code: 'en', flag: 'fi fi-gb', nativeName: 'English' },
        us: { code: 'us', flag: 'fi fi-us', nativeName: 'English (US)' },
      }
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale || localStorage.getItem('MY_LANG_SOLTANCASH') || 'ar';
    },
    availableLanguages() {
      // إحضار اللغات المتاحة في i18n ومطابقتها مع البيانات
      const locales = this.$i18n.availableLocales || ['ar', 'tr', 'en'];
      return locales.map(code => {
        return this.languagesList[code] || {
          code: code,
          flag: `fi fi-${code}`,
          nativeName: code.toUpperCase()
        };
      });
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    getFlagClass(code) {
      return this.languagesList[code]?.flag || `fi fi-${code}`;
    },
    getLangName(code) {
      return this.languagesList[code]?.nativeName || code.toUpperCase();
    },
    selectLanguage(code) {
      if (this.currentLocale !== code) {
        _changeSwitchLang(code);
        if (this.$i18n) {
          this.$i18n.locale = code;
        }
      }
      this.closeDropdown();
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownRef;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.lang-selector-wrapper {
  position: relative;
  display: inline-block;
  user-select: none;
}

/* زر التبديل الرئيسي */
.lang-trigger-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  background: var(--box-background, #ffffff);
  border: 1px solid rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.12);
  border-radius: 10px;
  color: var(--color-text, #222222);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.05);
  transition: all 0.25s ease;
  font-size: 13px;
  font-weight: 500;
}

.lang-trigger-btn:hover {
  border-color: rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.25);
  box-shadow: 0 4px 12px rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.1);
  transform: translateY(-1px);
}

.lang-trigger-btn.is-active {
  border-color: var(--primary-color, #2563eb);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.flag-icon {
  width: 20px;
  height: 15px;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.lang-label {
  line-height: 1;
}

.arrow-icon {
  font-size: 14px;
  color: var(--color-text-secondary, #777777);
  transition: transform 0.3s ease;
}

.lang-trigger-btn.is-active .arrow-icon {
  transform: rotate(180deg);
  color: var(--primary-color, #2563eb);
}

/* القائمة المنسدلة */
.lang-menu {
  position: absolute;

  bottom: calc(100% + 8px);
      left: 0;
    right: 0;
  inset-inline-end: 0;
  min-width: 175px;
  background: var(--box-background, #ffffff);
  border: 1px solid rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.08);
  border-radius: 14px;
  padding: 6px;
  box-shadow: 0 10px 30px rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.15);
  z-index: 10000;
  backdrop-filter: blur(8px);
}

/* خيار اللغة */
.lang-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.lang-item:hover {
  background: rgba(var(--color-box-shadow-rgb, 0, 0, 0), 0.05);
}

.lang-item.is-selected {
  background: rgba(37, 99, 235, 0.08);
}

.lang-item-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lang-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.lang-native-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text, #111827);
  line-height: 1.2;
}

.lang-sub-code {
  font-size: 10px;
  color: var(--color-text-secondary, #6b7280);
  font-weight: 500;
  letter-spacing: 0.5px;
}

.check-icon {
  font-size: 17px;
  color: var(--primary-color, #2563eb);
  margin-inline-start: 8px;
}

/* حركة الفتح والإغلاق (Transitions) */
.dropdown-anim-enter-active,
.dropdown-anim-leave-active {
  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.dropdown-anim-enter-from,
.dropdown-anim-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.96);
}
</style>